import Layout from "components/layout";
import { GetServerSidePropsContext, GetStaticProps } from "next";
import { NextSeoProps, NextSeo } from "next-seo";
import { ReactNode } from "react";
import { PageTitle } from "shared/components/molecules/PageTitle";
import { styled } from "twin.macro";
import { MetaTag } from "utils/seo";
import getNextSeoProps from "utils/ssr/getNextSeoProps";

const Dl = styled.dl`
  dt {
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 10px;
  }

  dd {
    font-size: 13px;
    line-height: 1.4;
    margin: 0 0 10px;
  }

  dd + dt {
    margin-top: 30px;
  }

  dd ul {
    margin: 10px 20px;
  }

  dd li {
    margin: 0 0 10px;
  }
`;

const Sakutei = styled.p`
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 20px;
  text-align: right;
`;

interface Props {
  nextSeoProps: NextSeoProps;
}

const Terms = ({ nextSeoProps }: Props) => {
  return (
    <>
      <NextSeo {...nextSeoProps} />
      <PageTitle title="利用規約" />
      <div tw="px-5">
        <div>
          <Dl>
            <dt>第1条（規約の適用等）</dt>
            <dd>
              1.
              MIROR利用規約（ユーザー用）（以下「本利用規約」といいます。）は、株式会社ラップス（以下「当社」といいます。）と当社の運営する本格チャット占いサイト「MIROR」（以下「本サイト」といいます。）の利用者（第2条に基づきユーザー登録を完了した者をいい、以下「ユーザー」といいます。）との間で、本サイト上で当社が提供するサービス及び当社が本サイトに関連してユーザーに提供するアプリケーション等（以下、総称して「本サービス」といいます）の利用に関する条件を定めるものです。
            </dd>
            <dd>
              2.
              本利用規約は、ユーザーにあらかじめ通知することなく変更されることがあります。変更後の本利用規約は、別途定める場合を除いて、本サイト上に表示された時点より効力を生じるものとします。ユーザーが、本利用規約の変更後に本サイト又は本サービスを利用したときに、当該変更に同意したものとみなされ、変更後の本利用規約が適用されるものとします。
            </dd>
            <dd>
              3.
              ユーザーが未成年者である場合は、本サービスの利用に関し、事前に親権者等の法定代理人の同意を得る必要があります。
            </dd>
            <dt>第2条（本サービスの利用・契約）</dt>
            <dd>
              ユーザーは、本利用規約の定めるところに従い、本サービスを通じて、本サイトに登録している占い師（以下「登録占い師」といいます。）の鑑定を受けることができます。鑑定に関する契約は、ユーザーと登録占い師との間で成立するものとし、当社は当該契約の当事者になるものではありません。
            </dd>
            <dt>第3条（ユーザー登録）</dt>
            <dd>
              1.
              本サイトを通じて登録占い師による鑑定を受けることを希望する者（以下「登録希望者」といいます。）は、本利用規約の定めるところに従いユーザー登録を行う必要があります。
            </dd>
            <dd>
              2.
              登録希望者によるユーザー登録の申請は、本サイトへのメールアドレスの登録又は当社が指定する第三者が提供するサービスのログイン情報を利用する方法により、行うものとします。
            </dd>
            <dd>
              3.
              ユーザー登録は、登録希望者が前項の申請手続を行い、当社がこれを承認することにより完了となります。
            </dd>
            <dd>
              4.
              当社は、登録希望者が以下に定める事由のいずれかに該当すると判断した場合、ユーザー登録を拒否することができるものとします。なお、当社は、当該拒否について一切の責任を負わず、また拒否の理由を説明する義務を負わないものとします。
              <ul>
                <li>
                  (1)
                  本利用規約に違反する行為を行うおそれがあると当社が判断した場合又は過去に本利用規約に違反した事実が判明した場合
                </li>
                <li>
                  (2)
                  ユーザー登録時に当社に提供された情報に虚偽の記載や記載漏れがあった場合
                </li>
                <li>
                  (3)
                  暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等その他これらに準ずる者（以下、総称して「反社会的勢力等」といいます。）に該当する、又は資金提供その他により反社会的勢力等の維持、運営に協力若しくは関与していると当社が判断する場合
                </li>
                <li>(4) その他当社が不適切と判断した場合</li>
              </ul>
            </dd>
            <dd>
              5.
              ユーザーは、ユーザー登録に際し当社に提供した情報に変更が生じた場合は、速やかに、本サイト上にて変更手続を行うものとします。ユーザーは、速やかに変更手続を行わないことにより、ユーザー自身、当社又は第三者に生じた損害について責任を負うものとします。
            </dd>
            <dd>
              6.
              ユーザーは、本サイトを利用するためのID及びパスワード（以下、総称して「ID等」といいます。）を第三者に使用、譲渡、貸与、開示等せず、厳重に管理するものとします。当社は、ID等が第三者に利用されたことに起因して生じるいかなる損害（ただし、当社の責めに帰すべき事由によるものを除きます。）について、一切の責任を負わないものとします。
            </dd>
            <dt>第4条（鑑定の申込み・鑑定契約）</dt>
            <dd>
              1.
              ユーザーは、本サイト上の当社が指定するフォームを用いて、その選択する登録占い師に対し、鑑定を申し込むことができます（以下「本鑑定申込」といいます。）。
            </dd>
            <dd>
              2.
              ユーザーは、本鑑定申込にあたっては、登録占い師による鑑定の方法として、「チャット鑑定」及び「電話鑑定」のいずれかを選択するものとします。
            </dd>
            <dd>
              3.
              本鑑定申込は、本鑑定申込を受けた登録占い師が、本サイトのシステム上で受諾することにより完了すし、ユーザーと登録占い師との間で鑑定に関する契約（以下「本鑑定契約」といいます。）が締結されます。当社は、本鑑定契約の当事者ではなく、本鑑定契約上何らの責任を負うものでもありません。本サイトを通じてユーザーに対して鑑定行為を行うのは登録占い師であり、当社は本サービスの運営主体であって、ユーザーに対して鑑定結果の提供を行うものではなく、これらの行為についていかなる責任も負いません。
            </dd>
            <dd>
              4.
              ユーザーは、自らの責任において本鑑定申込を行い、登録占い師との間で本鑑定契約を締結し、本サービスを利用するものとします。ユーザーは、登録占い師による鑑定結果が必ずしも自己の希望に合致するものではないものであることを了承の上、本サービスを利用するものであり、ユーザーによる本サービスの利用に関し生じた損害について、当社の責めに帰すべき事由がある場合を除き、当社は一切責任を負わないものとします。
            </dd>
            <dd>
              5.
              本鑑定契約に関連して生じた問い合わせ、苦情、請求、紛争等については、ユーザー及び登録占い師の間で解決するものとします。当社は、これらの紛争等については、一切責任を負いません。
            </dd>
            <dd>
              6.
              ユーザーは、本サイトを経由せずに、登録占い師との間で直接本鑑定契約を締結してはならず、登録占い師の鑑定を受けてはならないものとします。ユーザーが、本項に違反した場合は、違約金として、本鑑定料の3倍の金額を当社に対して支払わなければなりません。
            </dd>
            <dt>第5条（鑑定料）</dt>
            <dd>
              1.
              ユーザーは、前条に基づき登録占い師との間に本鑑定契約が締結された場合は、当社の定める方法に従い、本サイトにおいて定める鑑定料（以下「本鑑定料」といいます。）及びこれに対する消費税相当額を支払うものとします。当社は、登録占い師に代行して、ユーザーの支払う本鑑定料及び消費税相当額を受領するものとし、ユーザーによる本鑑定料の支払は、当社による受領をもって完了となります。
            </dd>
            <dd>
              2.
              当社は、ユーザーから既に支払われた本鑑定料及び消費税相当額については、原則として、キャンセルその他の理由を問わず一切返還しないものとします。
            </dd>
            <dt>第6条（【MIRORポイント】）</dt>
            <dd>
              1.
              ユーザーは、本サイトにおける鑑定の購入その他当社の定める場合に、【MIRORポイント】が付与されます。
            </dd>
            <dd>
              2.
              ユーザーは、【MIRORポイント】が付与された後、本サイトにおける鑑定の購入その他の有償サービスの利用のため、【MIRORポイント】を1ポイント＝1円として利用することができます。
            </dd>
            <dd>3. 【MIRORポイント】には有効期限を設定しないものとします。</dd>
            <dd>
              4.
              ユーザーは、【MIRORポイント】を第三者に貸与、譲渡、売買し、又は質権の設定その他の担保に供する等の行為を行ってはならないものとします。
            </dd>
            <dd>
              5.
              ユーザーは、本サービスの終了（その理由の如何を問いません。）に伴い【MIRORポイント】が利用できなくなることがありうることを、あらかじめ了承するものとします。当社は、このように【MIRORポイント】が利用できなくなることについては、ユーザーに対してあらかじめ告知するよう努めるものとします。
            </dd>
            <dt>第7条（サービスの一時停止）</dt>
            <dd>
              当社は、以下の各号のいずれかに該当する場合には、ユーザーに対する事前通知なしに、本サービスの提供を一時的に停止することができるものとします。当該一時停止により、ユーザーに損害が生じたとしても当社は何ら責任を負わないものとします。
              <ul>
                <li>
                  (1)
                  本サービスにかかるサーバーの保守、本サービスの障害復旧若しくは定期メンテナンス、又は本サービスについて仕様変更若しくは本サービスの瑕疵の修補等を行う場合
                </li>
                <li>
                  (2)
                  天災地変その他非常事態が発生し、若しくは発生するおそれがあり、又は法令等の改正、成立により本サービスの運営が困難又は不可能になった場合
                </li>
                <li>
                  (3)
                  その他当社がやむを得ない事由により本サービスの運営上一時的な停止が必要と判断した場合
                </li>
              </ul>
            </dd>
            <dt>第8条（サービスの停止・ユーザー登録の削除）</dt>
            <dd>
              1.
              当社は、ユーザーが以下のいずれかの事由に該当する場合、当該ユーザーに何ら通知することなく、当該ユーザーの本サービスの一部又は全部の利用を停止すること、又は当該ユーザーの登録を削除することができるものとします。ただし、当社は、当該停止又は登録削除について生じたユーザーの損害に対して一切の責任を負いません。
              <ul>
                <li>(1) ユーザーが本利用規約に違反した場合</li>
                <li>(2) 本鑑定料の支払いを1回でも怠った場合</li>
                <li>(3) ユーザーが支払停止になった場合</li>
                <li>
                  (4)
                  ユーザーが差押、仮差押、仮処分の申立、若しくは滞納処分を受けた場合、又は破産手続開始、民事再生手続開始の申立を受けた場合、若しくはこれらの申立を自らした場合
                </li>
                <li>
                  (5)
                  ユーザーが反社会的勢力等に該当する、又は資金提供その他により反社会的勢力等の維持、運営に協力若しくは関与していると当社が判断する場合
                </li>
                <li>
                  (6)
                  その他ユーザーによる本サービスの利用が不適切であると当社が判断する場合
                </li>
              </ul>
            </dd>
            <dd>
              2.
              ユーザーは、自らユーザー登録の削除を希望する場合、当社の定める方法により通知することによりこれを行うことができます。
            </dd>
            <dt>第9条（本サイト・本サービスの変更等）</dt>
            <dd>
              1.
              当社は、当社が必要と判断した場合には、ユーザーに通知することなく、いつでも本サイト又は本サービスを変更、バージョンアップ、停止、中止又は終了することができるものとし、これらにより、ユーザーに生じた不利益又は損害について、一切責任を負わないものとします。
            </dd>
            <dd>
              2.
              本サイト又は本サービスが変更、バージョンアップ、停止、中止又は終了した場合であっても、これらの事象が生じる前にユーザー及び登録占い師との間で成立した本鑑定契約は何ら影響を受けないものとします。
            </dd>
            <dt>第10条（第三者のサービス）</dt>
            <dd>
              1.
              本サービスにおいて、第三者の運営するウェブサイト、アプリケーション等（以下「第三者アプリ等」といいます。）へのリンクが提示されることがあります。ユーザーが、これらの第三者アプリ等を利用する場合、当該第三者の利用規約及びプライバシーポリシーに従い、自らの責任でこれを利用するものとします。これらの第三者アプリ等及び第三者アプリ等で提供される製品及びサービス、又は第三者の作為若しくは不作為については、これを提供する第三者たる事業者が責任を負い、当社は一切の責任を負いません。
            </dd>
            <dd>
              2.
              第三者のウェブサイトが、当社の承諾の有無を問わず、本サイトへのリンクを提供することがあります。当社は、これら第三者のウェブサイトに関連してユーザーが被った損害について責任を負いません。
            </dd>
            <dt>第11条（知的財産権・コンテンツ）</dt>
            <dd>
              1.
              本サイト及び本サービスに関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本利用規約に基づく本サービスの利用許諾は、本サイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
            </dd>
            <dd>
              2.
              ユーザーが本サイト又は本サービスにおいて投稿又は送信した文章、画像その他のコンテンツ（以下「本コンテンツ」といいます。）に関する知的財産権は、引き続きユーザー又はユーザーにライセンスを許諾している者が保持するものとします。
            </dd>
            <dd>
              3.
              ユーザーが本サイト又は本サービスにおいて投稿又は送信した本コンテンツに関する一切の責任は、当該ユーザーが負うものとし、当社は、その内容、品質、正確性等について確認せず、一切責任を負わないものとします。
            </dd>
            <dd>
              4.
              当社は、本コンテンツのバックアップを行う義務を負わないものとします。ユーザーが、本コンテンツのバックアップを行う場合は、自己の費用及び責任においてこれを行うものとします。
            </dd>
            <dd>
              5.
              当社は、ユーザーが本サイト又は本サービスにおいて投稿又は送信した本コンテンツについて、本利用規約への違反その他の理由により不適切であると判断した場合は、その任意の判断により、ユーザーに通知することなく、本コンテンツを削除又は修正することができるものとします。
            </dd>
            <dd>
              6.
              ユーザーは、当社が本サイト又は本サービスの適正な運営のため、本コンテンツのモニタリングを行うことについて、了承するものとします。
            </dd>
            <dt>第12条（個人情報・プライバシー情報）</dt>
            <dd>
              当社は、本サイト又は本サービスを通じて取得するユーザーの個人情報その他のプライバシー情報を、別途定めるプライバシーポリシーに従って適切に取り扱います。当該方針はこちら（https://miror.jp/privacy_policy）からご覧いただけますので、内容をご確認し、同意の上、本サービスをご利用ください。
            </dd>
            <dt>第13条（禁止事項）</dt>
            <dd>
              1. ユーザーは以下の各号に記載する行為を行わないものとします。
              <ul>
                <li>
                  (1)
                  本サービスの利用に関し、自ら又は第三者のために不正な利益を得ようとする行為
                </li>
                <li>
                  (2)
                  不正行為を行うソフトウェア、自動ソフトウェア、ボット、ハック、無断改変その他の許可されていない第三者のソフトウェアを作成する又は作成を助ける意図で本サービスを利用する行為
                </li>
                <li>
                  (3)
                  中傷、悪用、嫌がらせ、付きまとい、脅しその他の第三者の法的権利（プライバシー権又は肖像権を含みますがこれらに限られません。）を害するため、又は他のユーザーを特定する個人情報を収集するために本サービスを利用する行為
                </li>
                <li>
                  (4)
                  本サービス又は本サービスを提供するためのサーバーやネットワークの運営を妨害する行為。この行為には不合理又は不均衡に大きな負荷を本サイト、本サイト又は本サービスのためのサーバー若しくはネットワークにかけること、又はこれらのネットワークの要件、手続き、ポリシー、規則に違反することを含みます。
                </li>
                <li>
                  (5)
                  ハッキングや本サイトの一部を書き換えること等により、第三者が本サービスを利用することを制限又は阻害する行為
                </li>
                <li>
                  (6)
                  本サイト又は本サービスにおいて提供されるプログラムの全部又は一部について、修正、改変、翻案の創作、翻訳、リバースエンジニアリング、逆コンパイル又は逆アセンブルをする行為
                </li>
                <li>
                  (7)
                  本サイト又は本サービスに由来する素材に表示されている著作権、商標その他の財産権の表示を削除する行為
                </li>
                <li>
                  (8)
                  当社の事前の書面による承諾なしに、本サイト又は本サービスのいかなる部分であれフレーム又はミラーを作成する行為
                </li>
                <li>
                  (9)
                  本サイト上で若しくは本サイトを経由して又は本サービスに関連して、システムにより情報及び素材をダウンロードし、保持することによってデータベースを作成する行為
                </li>
                <li>
                  (10)
                  当社の事前の書面による承諾なしに、本サイト上で若しくは本サイトを経由して又は本サービスに関連して、利用可能な情報及び素材を取り出し、インデックスを作成し、抽出し、データマイニングその他の方法で収集するため、又は本サイト又は本サービスのナビゲーション構造若しくは表示を回避し又は複製するために、ロボット、スパイダー、サイト検索・解析アプリケーションその他手動又は自動の装置を利用する行為
                </li>
                <li>
                  (11) 自ら又は第三者を利用してする次の各号に該当する行為
                  <ul>
                    <li>① 暴力的な要求行為</li>
                    <li>② 法的な責任を超えた不当な要求行為</li>
                    <li>
                      ③ 取引に関して、脅迫的な言動をし、又は暴力を用いる行為
                    </li>
                    <li>
                      ④
                      風説を流布し、偽計を用い若しくは威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為
                    </li>
                    <li>⑤ その他前各号に準ずる行為</li>
                  </ul>
                </li>
              </ul>
            </dd>
            <dd>
              2.
              前項に加えて、当社は、本サービスの利用について、ユーザーの故意・過失を問わず、以下の各号に該当する又は該当するおそれがあると当社が判断する行為を禁止し、ユーザーはこれらの行為を行わないものとします。
              <ul>
                <li>
                  (1)反社会的行為
                  <ul>
                    <li>① 法令又は公序良俗に違反する行為</li>
                    <li>② 犯罪行為又はこれを予告、関与、助長する行為</li>
                    <li>
                      ③
                      虚偽又は誤解を招くような内容を含む情報等を掲載、登録する等の行為
                    </li>
                    <li>
                      ④
                      通常利用の範囲を超えてサーバーに負担をかける行為、及びそれを助長するような行為、その他本サービスの運営・提供又は他のユーザー若しくは登録占い師による本サービスの利用を妨害し、又はそれらに支障をきたす行為
                    </li>
                    <li>
                      ⑤
                      第三者の知的財産権（特許権、商標権、著作権及び企業秘密等）を侵害する行為
                    </li>
                    <li>
                      ⑥
                      第三者の信用若しくは名誉を侵害し、又は第三者のプライバシー権、肖像権その他一切の権利を侵害する行為
                    </li>
                    <li>
                      ⑦
                      自殺、自傷行為、薬物乱用等を美化・誘発・助長するおそれのある言葉、その他の表現の掲載行為
                    </li>
                    <li>
                      ⑧
                      ストーキング行為を行う等、方法のいかんを問わず、第三者に対する嫌がらせ又は第三者を中傷する行為
                    </li>
                    <li>
                      ⑨
                      民族・人種・性別・年齢等による差別につながる表現の掲載行為
                    </li>
                    <li>
                      ⑩
                      当社の役職員又は登録占い師が迷惑や不快感を感じるおそれのある行為
                    </li>
                  </ul>
                </li>
                <li>
                  (2)わいせつ・暴力的表現・出会い目的行為
                  <ul>
                    <li>
                      ①
                      モザイク、ぼかしの有無、美術性にかかわらず、下着姿を含む露出度の高いヌード、胸や臀部等のアップや性器が露出した写真等、その他卑猥と判断される画像・映像（動画）・イラスト・絵画の掲載、及び性行為や性器に該当する言葉、その他わいせつ的な表現の掲載行為
                    </li>
                    <li>
                      ②
                      暴力的、グロテスクな写真、及びその他一般ユーザー又は当社の役職員又は登録占い師が不快に感じる画像、言葉等、その他の表現の掲載行為
                    </li>
                    <li>
                      ③
                      本サービス内での性行為表現、又はそれを意図した表現の掲載行為
                    </li>
                    <li>④ リンクを張る等して、アダルトサイトに誘導する行為</li>
                    <li>
                      ⑤
                      児童買春・ポルノ、無修正ビデオ映像のダウンロードサイト等へのリンク掲載行為
                    </li>
                    <li>
                      ⑥ 本サービスを使ってアダルト関係の商品について紹介する行為
                    </li>
                    <li>
                      ⑦
                      異性との出会い等を希望、又は誘導することが主目的であると当社が判断する一切の行為
                    </li>
                    <li>
                      ⑧
                      その他、未成年者の人格形成等に悪影響を与えると判断される行為（刺青・未成年者の飲酒、喫煙等）
                    </li>
                  </ul>
                </li>
                <li>
                  (3)商業行為
                  <ul>
                    <li>
                      ①
                      ユーザーが、本サービスを通じて入手した全ての情報について、本鑑定契約の締結又は当該契約の履行目的以外に、複製、販売、出版、公開その他の方法で使用する行為、また、ユーザー以外の第三者をして同様の行為をさせる行為
                    </li>
                    <li>
                      ②
                      当社が許可したものを除き、営利又は非営利目的を問わず、本サービス以外のサービスや物の売買、交換、宣伝、勧誘、提供を目的とする情報の掲載
                    </li>
                    <li>
                      ③ 次に掲げる内容の情報を、掲載又は送信する行為
                      <ul>
                        <li>
                          (a)
                          ねずみ講、チェーンメッセージ、マルチレベルマーケティング等の第三者を勧誘する内容の情報
                        </li>
                        <li>
                          (b)
                          アフィリエイトや招待することでポイント等の利益が発生するサイトへ誘導する情報（ただし、当社が認めるものを除きます。）
                        </li>
                        <li>(c) 情報商材を含む情報</li>
                      </ul>
                    </li>
                    <li>
                      ④
                      他のユーザー又は当社に所属する役職員の個人情報を収集、蓄積する行為、又はこれらの行為をしようとする行為
                    </li>
                  </ul>
                </li>
                <li>
                  (4)その他
                  <ul>
                    <li>① 第三者になりすます行為</li>
                    <li>② 政治活動、宗教活動行為</li>
                    <li>
                      ③
                      違反行為により本サービスの利用を停止又は登録を削除されたユーザーが再度本サービスを利用する行為
                    </li>
                    <li>
                      ④
                      本サービスを利用して、反社会的勢力等の活動を助長又は反社会的勢力等に直接的若しくは間接的に利益を供与する行為
                    </li>
                    <li>
                      ⑤ その他、当社が、合理的な理由に基づき不適切と判断する行為
                    </li>
                  </ul>
                </li>
              </ul>
            </dd>
            <dt>第14条（非保証・免責）</dt>
            <dd>
              1.
              当社は、明示的か黙示的かを問わず、本サイトを含む本サービスについて、以下の事項を含む、いかなる事項に関して保証するものではありません。
              <ul>
                <li>(1) 本サービスが中断しないこと又はエラーがないこと</li>
                <li>
                  (2)
                  本サービスの障害、又は本サービスの操作若しくは通信に関するエラー、省略、中断、消去、欠陥、運営や送信の遅延、通信回線障害がないこと
                </li>
                <li>
                  (3)
                  本サービスに表示するコンテンツに盗用、毀損又は改ざんがないこと
                </li>
                <li>
                  (4)
                  本サービスに対する不正アクセス・ハッキング等のサイバー攻撃がないこと
                </li>
                <li>
                  (5)
                  本サービス及びその内容が正確、完全、確実、最新であること又はウイルスその他の有害な要素を含んでいないこと
                </li>
                <li>
                  (6)
                  ユーザーによる本サービスの利用環境及び利用機器・端末において正確に動作すること
                </li>
              </ul>
            </dd>
            <dd>
              2.
              ユーザーは、本サービスの利用に起因又は関連して損害が生じた場合について、当社の責めに帰すべき事由がある場合に限り、当社に対し損害賠償を請求することができるものとします。また、ユーザーは、当社に故意又は重過失がある場合を除き、いかなる場合においても、(i)かかる損害賠償の対象が現実に発生した、直接かつ通常の範囲の損害に限定されること、及び(ii)当社がユーザーに対して賠償する損害の累計額が、当社が当該ユーザーから受領した本鑑定料の合計額を上限とすることに同意します。
            </dd>
            <dd>
              3.
              当社は、本サイト又は本サービスに関連して取得され情報が完全、正確又は最新のものであることを何ら保証するものではありません。当社は、ユーザーがこれらの情報を使用又は依拠したことに関して、責任を負いません。
            </dd>
            <dd>
              4.
              当社は、登録占い師の専門性又は技量を保証するものではなく、登録占い師による専門性又は技量の不足によりユーザーに生じた一切の損害について、責任を負いません。
            </dd>
            <dd>
              5.
              当社は、登録占い師の本鑑定契約における作為若しくは不作為又はその他の作為若しくは不作為について、一切の責任を負いません。
            </dd>
            <dt>第15条（地位譲渡）</dt>
            <dd>
              1.
              ユーザーは、当社の書面による承諾がなければ、本利用規約上の地位又は本利用規約に基づき生ずる権利義務について、第三者に対して譲渡、移転、担保設定又はその他の処分をすることができません。
            </dd>
            <dd>
              2.
              当社は、本サービスにかかる事業を第三者に譲渡する場合、当該事業譲渡に伴い本利用規約上の地位、本利用規約に基づき生じる権利義務及びユーザーから本サービス利用に関して取得した全ての情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき予め同意するものとします。なお、本規定における事業譲渡には、通常の事業譲渡のみならず、合併、会社分割その他事業が移転するあらゆる場合を含むものとします。
            </dd>
            <dt>第16条（法の可分性）</dt>
            <dd>
              本利用規約の条項が、法令に抵触すると判断された場合又はいずれの当事者との関係においても法的拘束力を有しないと判断された場合、当該条項は、当該法令に抵触し又は法的拘束力を有しないと判断された限度で無効とみなされるものとし、本利用規約の他の全ての条項は有効に存続するものとします。
            </dd>
            <dt>第17条（準拠法と裁判管轄） </dt>
            <dd>1. 本利用規約は、日本法に準拠し、これによって解釈されます。</dd>
            <dd>
              2.
              本利用規約に起因又は関連して生じた全ての紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とするものとします。
            </dd>
            <Sakutei>2017年8月25日制定</Sakutei>
            <Sakutei>2018年8月22日改定</Sakutei>
            <Sakutei>2021年9月6日改定</Sakutei>
          </Dl>
        </div>
      </div>
    </>
  );
};

Terms.getLayout = (page: ReactNode) => {
  return <Layout nav={null}>{page}</Layout>;
};

export const getStaticProps: GetStaticProps = async (
  ctx: GetServerSidePropsContext
) => {
  const nextSeoProps = getNextSeoProps(ctx, {
    title: MetaTag.guideline.title,
    description: MetaTag.guideline.description,
  });
  return {
    props: {
      nextSeoProps,
    },
  };
};

export default Terms;
